<template>
  <div
    class="modal fade"
    :class="show ? 'show' : 'hide'"
    style="display: block; background-color: rgba(0, 0, 0, 0.3)"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Error details</h4>
        </div>
        <div class="modal-body">
          <div class="modal-body-content">
            <el-card class="selected-file">
              <div slot="header" class="clearfix">
                <h6>
                  File Name:
                  <span class="bold">{{ file.name }}</span>
                  <i
                    v-if="file.errors && file.errors.length"
                    class="el-icon-warning"
                    style="color: #ec4141"
                  ></i>
                  <i v-else class="el-icon-success" style="color: #4cea54"></i>
                </h6>
              </div>
              <el-descriptions :column="1">
                <el-descriptions-item label="Upload date">
                  {{ `${file.date.slice(0, 10)} ${file.date.slice(11, 19)}` }}
                </el-descriptions-item>
              </el-descriptions>
              <el-descriptions
                v-for="err in file.errors"
                :key="err.id"
                title="Details"
                :column="2"
              >
                <el-descriptions-item label="ID">
                  {{ err.id }}
                </el-descriptions-item>
                <el-descriptions-item label="Message">
                  {{ err.high_msg }}
                </el-descriptions-item>
                <el-descriptions-item label="Detailed message">
                  {{ err.msg }}
                </el-descriptions-item>
              </el-descriptions>
            </el-card>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn light-button" @click="close" type="button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorDetailsPopup',
  props: {
    file: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    async showPopup () {
      this.show = true
    },
    close () {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.hide {
  height: 0;
}

.show {
  height: 100%;
}

.bold {
  font-weight: bold;
}
.modal-dialog {
  margin-top: 90px;
  margin-left: 310px;
}

.modal-content {
  width: 60vw;
  max-height: 80vh;
  min-height: 215px;
  background-color: white !important;
  border: 1px solid #d1d4d7 !important;
  border-radius: 4px;
  overflow-y: scroll;

  .modal-header {
    display: flex;
    justify-content: flex-start;
    height: 42px;
    width: 100%;
    margin-top: 33px;
    align-items: flex-end;
    padding-left: 42px;

    .modal-title {
      font-family: "Source Sans Pro", sans-serif;
      font-size: 20px;
      font-weight: 900;
      line-height: 23px;
      letter-spacing: 0;
      margin-left: 41px;
    }
  }

  .modal-body {
    margin-top: 10px;
    margin-left: 10px;
    display: block;

    span {
      font-family: "Source Sans Pro", sans-serif;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0;
    }
  }
}
</style>
